import React, { ReactElement } from 'react';
import clsx from 'clsx';
import { Typography } from 'ui-components';
import { useGetAppVersion } from 'app-shared/lib/api/app-version';
import { CopyrightsProps } from './copyrights.interfaces';

import styles from './copyrights.module.scss';

const CopyRights = (props: CopyrightsProps): ReactElement => {
  const { label, className } = props;
  const year = new Date().getFullYear();
  const { data: appVersion } = useGetAppVersion();

  return (
    <div className={clsx(styles.container, className)}>
      <Typography variant="caption" align="center" className={styles.text}>
        Circlee © {year} {label}
      </Typography>
      {appVersion && (
        <Typography variant="caption" align="center" className={styles.text}>
          {appVersion.version}
        </Typography>
      )}
    </div>
  );
};

export default CopyRights;
